import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_URL, DEFAULT_OG_IMAGE, ORGANIZATION_SCHEMA } from '../seo/siteConfig';

function upsertMeta(attr, key, content) {
  if (content == null || content === '') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  const json = JSON.stringify(data);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = json;
}

/**
 * Updates document title, meta tags, canonical URL, Open Graph, Twitter cards, and optional JSON-LD.
 */
export function useSEO({
  title,
  description,
  keywords,
  path,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) {
  const location = useLocation();
  const canonicalPath = path ?? location.pathname;
  const canonical = `${SITE_URL}${canonicalPath === '/' ? '' : canonicalPath}`;
  const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  useEffect(() => {
    document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
    upsertMeta('name', 'author', 'Bharat Industrial Training');
    upsertMeta('name', 'geo.region', 'IN-UP');
    upsertMeta('name', 'geo.placename', 'Noida');

    upsertLink('canonical', canonical);

    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:site_name', 'Bharat Industrial Training');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', imageUrl);
    upsertMeta('property', 'og:locale', 'en_IN');

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', imageUrl);

    upsertJsonLd('seo-page-jsonld', jsonLd);
    upsertJsonLd('seo-org-jsonld', ORGANIZATION_SCHEMA);
  }, [title, description, keywords, canonical, imageUrl, type, noindex, jsonLd]);
}

export default function SEO(props) {
  useSEO(props);
  return null;
}
